import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';
import { map, Observable } from 'rxjs';
import { ConfirmationDialogComponent } from '../components/utils/confirmation-dialog/confirmation-dialog.component';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UnsavedFormChangesGuard implements CanDeactivate<CanComponentDeactivate> {
  dialog = inject(MatDialog);
  canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
    if (component.canDeactivate()) {
        return true; // Allow navigation if form is not dirty
    } 
  
    // Open the dialog and wait for the user's response
    return this.dialog
    .open(ConfirmationDialogComponent, {
        data: { message: "Unsaved changes will be lost if you navigate from this page. Do you want to continue?" }
    })
    .afterClosed()
    .pipe(map((result) => !!result)); // Convert the result to boolean
  }
}
